export const COSMOSTATION_OPERATOR_ADDRESS = 'dydxvaloper1vl5ty47uwpfv4mcutwv4zam09mvvvdgy09n0l5';
